module.exports = __webpack_public_path__ + "static/media/DINNextRoundedLTPro-Medium.547b42e4.otf";